module.exports = __webpack_public_path__ + "img/upload-default-img.86def55d.png";